
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.263 15.15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.794 3.377a36.166 36.166 0 005.608-2.8.428.428 0 01.455.009 24.914 24.914 0 005.586 2.811.429.429 0 01.308.483c-.316 1.975-1.958 10.773-6.118 10.773-4.177 0-5.815-8.867-6.122-10.8a.43.43 0 01.283-.476z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    